
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customize-bundle-for-dpu",
      function () {
        return require("private-next-pages/customize-bundle-for-dpu/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customize-bundle-for-dpu"])
      });
    }
  